<div style="position:relative; display:inline-block;">
    <input 
        type="number" 
        [style.width.em]="width" 
        [(ngModel)]="el[prop]"
        placeholder="(Empty)"
        [step]="step" 
        (click)="toggleSlider()"
     data-ui-name="(empty)" data-ui-component="num-scrub" data-testid="num-scrub-empty" aria-label="(Empty)">
    <div *ngIf="isSliderActive" class="slider-overlay-container">
        <div class="slider-overlay">
            <input 
                type="range" 
                [(ngModel)]="el[prop]"
                placeholder="(Empty)"
                [step]="step" 
                [min]="min" 
                [max]="max" 
                (change)="change.emit()"
             data-ui-name="(empty)" data-ui-component="num-scrub" data-testid="num-scrub-empty-0ede5e8" aria-label="(Empty)">
        </div>
    </div>
</div>